import React, {useState} from 'react';
import classNames from "classnames";


export function HeaderContent(props) {

    const [toggleEdit, setToggleEdit] = useState(false);

    const headerClasses = classNames(
        {
            "fs-1":props.level === 0,
            "fs-2":props.level === 1,
            "fs-3":props.level === 2,
        }
    );

    if(props.edit) {

        if(toggleEdit) {
            return (
                <input className={"form-control"} value={props.value} onInput={(e) => props.setContent(e.target.value)} onBlur={() => setToggleEdit(false)}/>
            );
        } else {
            return (<h1 className={headerClasses} onClick={() => setToggleEdit(true)}>{props.value}
            </h1>);

        }

    } else {
        return (
            <h1 className={headerClasses}>{props.value}</h1>
        );
    }

}